
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: "leadervoard_group",
    components: { VueSlickCarousel },
    props: ["item"],
    data(){
        return {
            isGroupLoading: false,
            isLoading: false,
            isSearching: false,

            modalTitle: "MYWELLNESS GROUP LEADERBOARD",
            confirmationItem: null,
            createGroupError: null,

            data: {},
            defaultData: {
                name: null,
                email: null,
                banner: 1,
            },
            myGroup: null,
            groupItem: null,
            userItem: null,
            myLeaderboard: null,
            leaderboard: [],
            leaderboardLimit: 250,
            invites: [],
            searchKeyword: null,
            searchGroups: [],

            maxGroupMembers: 5,

            achievements: [
                {
                    title: "Gone Global",
                    desc: "More than 3 entities represented."
                },
                {
                    title: "Full House",
                    desc: "Locked in a roster of 5 members."
                },
            ],

            weeklyTasksMeta: {
                build_the_beat: {
                    title: "BEAT CREW",
                    desc: "As a group, play Build the Beat at least 15 times this week.",
                    icon: 0,
                },
                jukebox: {
                    title: "JUKEBOX JAM",
                    desc: (task) => `As a group, play the Fiesta Jukebox at least 10 times this week.`,
                    icon: 1,
                },
                scavenger_hunt: {
                    title: "SEARCH PARTY",
                    desc: (task) => `As a group, find all the required Scavenger Hunt items this week.`,
                    icon: 2,
                },
                live_session: {
                    title: "THREE'S A CROWD",
                    desc: (task) => `Attended at least one live session as a trio or more.`,
                    icon: 3,
                },
            },

            currentStep: "landing",
            selectedLang: "en",
            langText: {
                en: {
                    prize_title: "PRIZES AND SCORING MECHANICS",
                    prize_desc_1: "There are more ways to win than ever before!",
                    prize_desc_2: "Make sure to get your friends on board; not only will the top 1,500 participants be rewarded, there are Group and referral-based prizes to be won as well.",
                    view_leaderboard: "VIEW LEADERBOARDS",
                },
                cn: {
                    prize_title: "奖励和计分机制",
                    prize_desc_1: "今年您将有更多机会赢取奖励！",
                    prize_desc_2: "快叫上您的好友一起参加吧！除了前1500名的参与者能够获得奖励之外，还有团队和推荐相关的奖励等着您哦！",
                    view_leaderboard: "查看排行榜",
                },
            },

            carouselOptions: {
                arrows: false,
                dots: false,
                edgeFriction: 0.35,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1
            },
        }
    },
    computed: {
        weeklyTasksList(){
            if(!this.groupItem?.tasks) return [];
            return Object.keys(this.weeklyTasksMeta).map(key => {
                const task = this.groupItem.tasks[key] || { progress: 0, target: 0, is_completed: false };
                const meta = this.weeklyTasksMeta[key];
                const percentage = task.target > 0 ? Math.min(100, (task.progress / task.target) * 100) : 0;
                return {
                    key,
                    title: meta.title,
                    desc: typeof meta.desc === "function" ? meta.desc(task) : meta.desc,
                    icon: meta.icon,
                    progress: task.progress,
                    target: task.target,
                    is_completed: task.is_completed,
                    barStyle: { width: `${percentage}%` },
                };
            });
        },
    },
    mounted(){
        this.data = { ...this.defaultData };
        this.onInitGroup();
    },
    methods: {
        onInitGroup(){
            this.isGroupLoading = true;
            this.$axios.$get(`/group?limit=${ this.leaderboardLimit }`, this.tokenHeader).then(res => {
                console.log("initGroupCallback", res);
                this.myGroup = res.item;
                this.leaderboard = res.leaderboard;
                this.myLeaderboard = res.my_leaderboard;
                this.invites = res.invites;
                this.isGroupLoading = false;
            }).catch((err) => {
                console.error("initGroupError", err);
                return this.onHandleApiError(err);
            });
        },
        onSelectBanner(item){
            this.data.banner = item + 1;
        },
        onClickGroupBtn(id){
            if(!this.isGroupLoading){
                this.isGroupLoading = true;

                this.onHandleTriggerAnalytics(`view@group`);

                this.$axios.$get(`/group/${ id }`, this.tokenHeader).then(res => {
                    console.log("getGroupDetailCallback", res);

                    this.groupItem = res.item;
                    this.currentStep = "group";
                    this.isGroupLoading = false;
                }).catch((err) => {
                    console.error("getGroupDetailError", err);
                    this.isGroupLoading = false;
                    return this.onHandleApiError(err);
                });
            }
        },
        onShowConfirmPopup(item){
            switch(item){
                case "create":
                    this.createGroupError = null;
                    if(!this.data.name) return this.createGroupError = "Group name field is required!";
                    this.confirmationItem = {
                        type: "create",
                        text: "Creating or joining a group is a permanent commitment - you won't be able to change details or groups later.",
                    };
                    break;
                case "apply":
                    this.confirmationItem = {
                        type: "apply",
                        text: "Creating or joining a group is a permanent commitment - you won't be able to switch later.",
                    };
                    break;
                case "invite":
                    if(!this.data.email) return this.$swal({ icon: "info", title: "Member email is required!" });
                    this.confirmationItem = {
                        type: "invite",
                        text: "Members cannot be changed later.",
                    };
                    break;
                case "accept_application":
                    this.confirmationItem = {
                        type: "accept_application",
                        text: "Once they've joined, you won't be able to change your mind later.",
                    };
                    break;
                case "accept_invitation":
                    this.confirmationItem = {
                        type: "accept_invitation",
                        text: "Creating or joining a group is a permanent commitment - you won't be able to change details or groups later.",
                    };
                    break;
            }
        },
        onClickConfirmBtn(){
            switch(this.confirmationItem.type){
                case "create":
                    this.onClickCreateBtn();
                    break;
                case "apply":
                    this.onClickApplyBtn();
                    break;
                case "invite":
                    this.onClickInviteBtn();
                    break;
                case "accept_application":
                    this.onClickUpdateRequest(true);
                    break;
                case "accept_invitation":
                    this.onClickUpdateInvite(true);
                    break;
            }
        },
        onClickCreateBtn(){
            if(!this.isLoading){
                this.isLoading = true;
                this.confirmationItem = null;

                this.onHandleTriggerAnalytics(`create@group`);

                this.$axios.$post("/group", this.data, this.tokenHeader).then(res => {
                    console.log("createGroupCallback", res);

                    this.myGroup = res.item;
                    this.data = { ...this.defaultData };
                    this.isLoading = false;
                    this.onClickGroupBtn(res.item.id);
                    this.$swal({ icon: "success", title: "Group successfully created." });

                    if(this.user.cid){
                        this.$socket.emit("createPublicRoom", { roomName: res.item.name, roomBanner: res.item.banner }, createChatRoomRes => {
                            console.log("createPublicRoomCallback", createChatRoomRes);

                            if(createChatRoomRes.item){
                                this.$socket.emit("joinPublicRoom", { roomCid: createChatRoomRes.item.roomCid, cid: this.user.cid }, joinChatRoomRes => {
                                    console.log("joinPublicRoomCallback", joinChatRoomRes);
                                });
                            }
                        });
                    }
                }).catch((err) => {
                    console.error("createGroupError", err);
                    this.isLoading = false;
                    this.createGroupError = err?.response?.data?.message ?? "Error";
                    // return this.onHandleApiError(err);
                });
            }
        },
        onClickSearchBtn(){
            if(!this.searchKeyword && !this.data.name) return this.$swal({ icon: "info", title: "All fields are required!" });

            if(!this.isSearching){
                this.isSearching = true;
                this.searchGroups = [];

                if(this.searchKeyword){
                    this.searchKeyword = null;
                    this.data = { ...this.defaultData };
                }else{
                    this.searchKeyword = this.data.name;
                    this.onHandleTriggerAnalytics(`search@group`);
                }

                this.$axios.$post("/group/search", { name: this.searchKeyword }, this.tokenHeader).then(res => {
                    console.log("searchGroupCallback", res);

                    this.isSearching = false;

                    if(res.items.length == 0){
                        this.data = { ...this.defaultData };
                        this.searchKeyword = null;
                        return this.$swal({ icon: "info", title: "No groups match your search." });
                    }

                    // this.data = { ...this.defaultData };
                    this.leaderboard = res.items;
                    // this.searchGroups = res.items;
                }).catch((err) => {
                    console.error("searchGroupError", err);
                    this.data = { ...this.defaultData };
                    this.isSearching = false;
                    return this.onHandleApiError(err);
                });
            }
        },
        onClickInviteBtn(){
            if(!this.isLoading){
                this.isLoading = true;
                this.confirmationItem = null;
                this.onHandleTriggerAnalytics(`invite@group`);

                this.$axios.$post(`/group/invite`, { email: this.data.email }, this.tokenHeader).then(res => {
                    console.log("inviteGroupCallback", res);
                    this.isLoading = false;
                    this.data = { ...this.defaultData };
                    this.$swal({ icon: "success", title: "Success!" });
                }).catch((err) => {
                    console.error("inviteGroupError", err);
                    this.data = { ...this.defaultData };
                    this.isLoading = false;
                    return this.onHandleApiError(err);
                });
            }
        },
        onClickApplyBtn(){
            if(!this.isLoading){
                this.isLoading = true;
                this.confirmationItem = null;
                this.onHandleTriggerAnalytics(`apply@group`);

                this.$axios.$post(`/group/apply`, { id: this.groupItem.id }, this.tokenHeader).then(res => {
                    console.log("applyGroupCallback", res);
                    this.groupItem.is_applied = true;
                    this.isLoading = false;
                    this.$swal({ icon: "success", title: "Application successful. The Group Leader will be prompted to review your application." });
                }).catch((err) => {
                    console.error("applyGroupError", err);
                    this.isLoading = false;
                    return this.onHandleApiError(err);
                });
            }
        },
        async onClickUpdateInvite(is_approve){
            if(!this.isLoading){
                this.isLoading = true;
                this.confirmationItem = null;
                this.onHandleTriggerAnalytics(`${ is_approve? "accept" : "decline" }_invitation@group`);

                this.$axios.$post(`/group/update_invite`, { id: this.groupItem.id, is_approve }, this.tokenHeader).then(res => {
                    console.log("updateGroupInvitetCallback", res);

                    this.isLoading = false;
                    if(is_approve){
                        this.invites = [];
                        this.myGroup = { ...res.item };
                        this.groupItem = { ...res.item };

                        if(res.chat_room_id){
                            this.$socket.emit("joinPublicRoom", { roomCid: res.chat_room_id, cid: this.user.cid }, joinChatRoomRes => {
                                console.log("joinPublicRoomCallback", joinChatRoomRes);
                            });
                        }
                    }else{
                        this.currentStep = "invitations";
                        this.invites = _.reject(this.invites, { id: this.groupItem.id });
                    }
                    this.$swal({ icon: "success", title: "Success!" });
                }).catch((err) => {
                    console.error("updateGroupInviteError", err);
                    this.isLoading = false;
                    return this.onHandleApiError(err);
                });
            }
        },
        async onClickUpdateRequest(is_approve){
            if(!this.isLoading){
                this.isLoading = true;
                this.confirmationItem = null;
                this.onHandleTriggerAnalytics(`${ is_approve? "accept" : "decline" }_application@group`);

                this.$axios.$post(`/group/update_request`, { id: this.userItem.id, is_approve }, this.tokenHeader).then(res => {
                    console.log("updateGroupRequestCallback", res);
                    this.isLoading = false;
                    this.groupItem.requests = _.reject(this.groupItem.requests, { id: this.userItem.id });

                    if(this.groupItem.requests.length == 0){
                        this.userItem = null;
                        this.onClickBackBtn();
                    }else{
                        this.userItem = this.groupItem.requests[0];
                    }

                    if(is_approve){
                        if(res.chat_room_id && res.user_chat_id){
                            this.$socket.emit("joinPublicRoom", { roomCid: res.chat_room_id, cid: res.user_chat_id }, joinChatRoomRes => {
                                console.log("joinPublicRoomCallback", joinChatRoomRes);
                            });
                        }

                        this.$swal({ icon: "success", title: "Application has been accepted. Hurrah!" });
                    }
                }).catch((err) => {
                    console.error("updateGrRequestoupError", err);
                    this.isLoading = false;
                    return this.onHandleApiError(err);
                });
            }
        },
        onClickBackBtn(){
            if(this.isLoading) return;
            this.onHandleTriggerAnalytics(`back@group`);

            this.searchGroups = [];
            this.searchKeyword = null;
            this.data = { ...this.defaultData };

            if(this.currentStep == "applications" || this.currentStep == "invite"){
                this.onClickGroupBtn(this.myGroup.id);
            }else{
                this.onInitGroup();
                this.groupItem = null;
                this.currentStep = "landing";
            }
        },
        onClickCloseBtn(){
            if(this.isLoading) return;
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@group`);
        },
    },
    watch: {
        "selectedLang"(){
            switch(this.currentStep){
                case "landing":
                    this.modalTitle = "MYWELLNESS GROUP LEADERBOARD";
                    break;
                case "create":
                    this.modalTitle = "CREATE / START A GROUP";
                    break;
                case "invite":
                    this.modalTitle = "INVITE MEMBERS";
                    break;
                case "invitations":
                    this.modalTitle = "MY INVITATIONS";
                    break;
                case "search":
                    this.modalTitle = "SEARCH FOR GROUPS";
                    break;
                case "group":
                    this.modalTitle = this.myGroup && this.myGroup.id == this.groupItem.id? "YOUR GROUP" : "GROUP INFORMATION";
                    break;
                case "applications":
                    this.modalTitle = "GROUP APPLICATIONS";
                    this.userItem = this.groupItem.requests[0];
                    break;
                case "prizes":
                    this.modalTitle =  this.langText[this.selectedLang].prize_title;
                    break;
            }
        },
        "currentStep"(item){
            switch(item){
                case "landing":
                    this.modalTitle = "MYWELLNESS GROUP LEADERBOARD";
                    break;
                case "create":
                    this.modalTitle = "CREATE / START A GROUP";
                    break;
                case "invite":
                    this.modalTitle = "INVITE MEMBERS";
                    break;
                case "invitations":
                    this.modalTitle = "MY INVITATIONS";
                    break;
                case "search":
                    this.modalTitle = "SEARCH FOR GROUPS";
                    break;
                case "group":
                    this.modalTitle = this.myGroup && this.myGroup.id == this.groupItem.id? "YOUR GROUP" : "GROUP INFORMATION";
                    break;
                case "applications":
                    this.modalTitle = "GROUP APPLICATIONS";
                    this.userItem = this.groupItem.requests[0];
                    break;
                case "prizes":
                    this.modalTitle =  this.langText[this.selectedLang].prize_title;
                    break;
            }
        }
    }
}
